import { render } from "./NotValid.vue?vue&type=template&id=1b9222d2"
import script from "./NotValid.vue?vue&type=script&lang=js"
export * from "./NotValid.vue?vue&type=script&lang=js"
script.render = render

export default script